const arrayName = [
 
   {
    src: "https://cdn.shopify.com/s/files/1/0492/7201/files/Screenshot2025-10-09at3.22.34PM.png?v=1760037759",
    name: "Rihanna",
  },
  {
    src: "https://cdn.shopify.com/s/files/1/0492/7201/files/Elizabeth_Kurpis.jpg?v=1682284172",
    name: "Elizabeth Kurpis",
  }, 
  {
    src: "https://cdn.shopify.com/s/files/1/0492/7201/files/Mariah_Carey.jpg?v=1767983338",
    name: "Mariah Carey",
  },
  {
    src: "https://cdn.shopify.com/s/files/1/0492/7201/files/Loren_Aldarondo.jpg?v=1767983338",
    name: "Loren Aldarondo",
  },
  {
    src: "https://cdn.shopify.com/s/files/1/0492/7201/files/Charlotte_Tillbury.jpg?v=1767983338",
    name: "Charlotte Tillbury",
  },
   {
    src: "https://cdn.shopify.com/s/files/1/0492/7201/files/Addison_Rae.jpg?v=1767983338",
    name: "Addison Rae",
  },
   {
    src: "https://cdn.shopify.com/s/files/1/0492/7201/files/Carter_Faith.jpg?v=1767983338",
    name: "Carter Faith",
  },
    {
    src: "https://cdn.shopify.com/s/files/1/0492/7201/files/Claire_Marie_Hall.jpg?v=1767983338",
    name: "Claire Marie Hall",
  },
    {
    src: "https://cdn.shopify.com/s/files/1/0492/7201/files/Sofia_Harmanda.jpg?v=1767983338",
    name: "Sofia Harmanda",
  },
  {
    src: "https://cdn.shopify.com/s/files/1/0492/7201/files/Elizabeth_Kurpis_5.jpg?v=1682284171",
    name: "Elizabeth Kurpis",
  },

  {
    src: "https://cdn.shopify.com/s/files/1/0492/7201/files/Emily_Ratajkowski_4.jpg?v=1682284171",
    name: "Emily Ratajkowski",
  },


  {
    src: "https://cdn.shopify.com/s/files/1/0492/7201/files/Heidi_Klum_4.jpg?v=1682284168",
    name: "Heidi Klum",
  },
  {
    src: "https://cdn.shopify.com/s/files/1/0492/7201/files/Taraji_P._Henson.jpg?v=1682284168",
    name: "Taraji P",
  },

  {
    src: "https://cdn.shopify.com/s/files/1/0492/7201/files/Nicky_Doll.jpg?v=1682284168",
    name: "Nicky Doll",
  },
  {
    src: "https://cdn.shopify.com/s/files/1/0492/7201/files/Joey_Wolffer.jpg?v=1682284167",
    name: "Joey Wolffer",
  },
  {
    src: "https://cdn.shopify.com/s/files/1/0492/7201/files/Norah_Jones_2.jpg?v=1682284166",
    name: "Norah Jones",
  },
  {
    src: "https://cdn.shopify.com/s/files/1/0492/7201/files/Miley_Cyrus_2.jpg?v=1682284167",
    name: "Miley Cyrus",
  },
  {
    src: "https://cdn.shopify.com/s/files/1/0492/7201/files/Mary_Yashan_Gui.jpg?v=1682284166",
    name: "Mary Yashan Gui",
  },

  {
    src: "https://cdn.shopify.com/s/files/1/0492/7201/files/Florence_Welch.jpg?v=1682284167",
    name: "Florence Welch",
  },
  {
    src: "https://cdn.shopify.com/s/files/1/0492/7201/files/Kendall_Jenner.jpg?v=1682284164",
    name: "Kendall Jenner",
  },
  {
    src: "https://cdn.shopify.com/s/files/1/0492/7201/files/Madonna_2.jpg?v=1682284167",
    name: "Madonna",
  },
  {
    src: "https://cdn.shopify.com/s/files/1/0492/7201/files/Emily_Ratajkowski_6.jpg?v=1682284164",
    name: "Emily Ratajkowski",
  },
  {
    src: "https://cdn.shopify.com/s/files/1/0492/7201/files/Kendall_Jenner.jpg?v=1682284164",
    name: "Kendall Jenner",
  },
  {
    src: "https://cdn.shopify.com/s/files/1/0492/7201/files/Emily_Ratajkowski_3.jpg?v=1682284164",
    name: "Emily Ratajkowski",
  },
  {
    src: "https://cdn.shopify.com/s/files/1/0492/7201/files/Amber_Heard.jpg?v=1682284164",
    name: "Amber Heard",
  },
  {
    src: "https://cdn.shopify.com/s/files/1/0492/7201/files/Kim_Kardashian_3.jpg?v=1682284163",
    name: "Kim Kardashian",
  },
  {
    src: "https://cdn.shopify.com/s/files/1/0492/7201/files/Kendall_Jenner_3.jpg?v=1682284163",
    name: "Kendall Jenner",
  },
  {
    src: "https://cdn.shopify.com/s/files/1/0492/7201/files/Emily_Ratajkowski_3.jpg?v=1682284164",
    name: "Emily Ratajkowski",
  },
  {
    src: "https://cdn.shopify.com/s/files/1/0492/7201/files/Kim_Kardashian_3.jpg?v=1682284163",
    name: "Kim Kardashian",
  },
  {
    src: "https://cdn.shopify.com/s/files/1/0492/7201/files/Kim_Kardashian_8.jpg?v=1682284163",
    name: "Kim Kardashian",
  },
  {
    src: "https://cdn.shopify.com/s/files/1/0492/7201/files/Miley_Cyrus_55fd74a5-0fdf-4cd0-b2f9-0f78cb20438c.jpg?v=1682284164",
    name: "Miley Cyrus",
  },

  {
    src: "https://cdn.shopify.com/s/files/1/0492/7201/files/Emily_Ratajkowski.jpg?v=1682284162",
    name: "Emily Ratajkowski",
  },
  {
    src: "https://cdn.shopify.com/s/files/1/0492/7201/files/Julia_Michaels.jpg?v=1682284162",
    name: "Julia Michaels",
  },
  {
    src: "https://cdn.shopify.com/s/files/1/0492/7201/files/Kehlani.jpg?v=1682284162",
    name: "Kehlani",
  },
  {
    src: "https://cdn.shopify.com/s/files/1/0492/7201/files/Kehlani_2.jpg?v=1682284161",
    name: "Kehlani",
  },
  {
    src: "https://cdn.shopify.com/s/files/1/0492/7201/files/Marilyn_Mason.jpg?v=1682284162",
    name: "Marilyn Mason",
  },
  {
    src: "https://cdn.shopify.com/s/files/1/0492/7201/files/Madonna_3.jpg?v=1682284161",
    name: "Madonna",
  },
  {
    src: "https://cdn.shopify.com/s/files/1/0492/7201/files/Heidi_Klum_3.jpg?v=1682284161",
    name: "Heidi Klum",
  },
  {
    src: "https://cdn.shopify.com/s/files/1/0492/7201/files/Bebe_Rexha.jpg?v=1682284161",
    name: "Bebe Rexha",
  },
  {
    src: "https://cdn.shopify.com/s/files/1/0492/7201/files/Emily_Ratajkowski_5.jpg?v=1682284161",
    name: "Emily Ratajkowski",
  },
  {
    src: "https://cdn.shopify.com/s/files/1/0492/7201/files/Emily_Ratajkowski_2.jpg?v=1682284161",
    name: "Emily Ratajkowski",
  },
  {
    src: "https://cdn.shopify.com/s/files/1/0492/7201/files/Gwen_Stefani.jpg?v=1682284161",
    name: "Gwen Stefani",
  },
  {
    src: "https://cdn.shopify.com/s/files/1/0492/7201/files/Liza_Koshy_2.jpg?v=1682284160",
    name: "Liza Koshy",
  },
  {
    src: "https://cdn.shopify.com/s/files/1/0492/7201/files/Kendal_Jenner.jpg?v=1682284159",
    name: "Kendal Jenner",
  },
  {
    src: "https://cdn.shopify.com/s/files/1/0492/7201/files/Kim_Kardashian_2.jpg?v=1682284159",
    name: "Kim Kardashian",
  },
  {
    src: "https://cdn.shopify.com/s/files/1/0492/7201/files/Kim_Kardashian_2.jpg?v=1682284159",
    name: "Kim Kardashian",
  },
  {
    src: "https://cdn.shopify.com/s/files/1/0492/7201/files/Norah_Jones.jpg?v=1682284158",
    name: "Norah Jones",
  },
  {
    src: "https://cdn.shopify.com/s/files/1/0492/7201/files/Madonna_4.jpg?v=1682284158",
    name: "Madonna",
  },
  {
    src: "https://cdn.shopify.com/s/files/1/0492/7201/files/Doja_Cat_57aa5a48-82f1-47a6-bf59-6f7fcedd0a9a.jpg?v=1682284157",
    name: "Doja Cat",
  },
  {
    src: "https://cdn.shopify.com/s/files/1/0492/7201/files/Jessica_Darrow.jpg?v=1682284155",
    name: "Jessica Darrow",
  },
  {
    src: "https://cdn.shopify.com/s/files/1/0492/7201/files/Selena_Gomez_3.jpg?v=1682284156",
    name: "Selena Gomez",
  },
  {
    src: "https://cdn.shopify.com/s/files/1/0492/7201/files/Nicky_Doll_5.jpg?v=1682284155",
    name: "Nicky Doll",
  },

  {
    src: "https://cdn.shopify.com/s/files/1/0492/7201/files/Grimes.jpg?v=1682284155",
    name: "Grimes",
  },
  {
    src: "https://cdn.shopify.com/s/files/1/0492/7201/files/Miranda_Lambert.jpg?v=1682284154",
    name: "Miranda Lambert",
  },
  {
    src: "https://cdn.shopify.com/s/files/1/0492/7201/files/Ellie_Goulding.jpg?v=1682284154",
    name: "Ellie Goulding",
  },
  {
    src: "https://cdn.shopify.com/s/files/1/0492/7201/files/Nicky_Doll_7.jpg?v=1682284154",
    name: "Nicky Doll",
  },
  {
    src: "https://cdn.shopify.com/s/files/1/0492/7201/files/Iman_14af5cc1-c871-4ac3-9195-5745660b3703.jpg?v=1682284154",
    name: "Iman",
  },
  {
    src: "https://cdn.shopify.com/s/files/1/0492/7201/files/Kim_Kardashian_9.jpg?v=1682284154",
    name: "Kim Kardashian",
  },
  {
    src: "https://cdn.shopify.com/s/files/1/0492/7201/files/Emily_Ratajkowski_8.jpg?v=1682284153",
    name: "Emily Ratajkowski",
  },
  {
    src: "https://cdn.shopify.com/s/files/1/0492/7201/files/Norah_Jones_3.jpg?v=1682284153",
    name: "Norah Jones",
  },
  {
    src: "https://cdn.shopify.com/s/files/1/0492/7201/files/Selena_Gomez_2.jpg?v=1682284150",
    name: "Selena Gomez",
  },
  {
    src: "https://cdn.shopify.com/s/files/1/0492/7201/files/Kourtney_Kardashian.jpg?v=1682284150",
    name: "Kourtney Kardashian",
  },
  {
    src: "https://cdn.shopify.com/s/files/1/0492/7201/files/Emily_Ratajkowski_7.jpg?v=1682284150",
    name: "Emily Ratajkowski",
  },
  {
    src: "https://cdn.shopify.com/s/files/1/0492/7201/files/Jessica_Darrow_2.jpg?v=1682284150",
    name: "Jessica Darrow",
  },
  {
    src: "https://cdn.shopify.com/s/files/1/0492/7201/files/Kim_Kardashian_7.jpg?v=1682284149",
    name: "Kim Kardashian",
  },
 
  {
    src: "https://cdn.shopify.com/s/files/1/0492/7201/files/Liza_Koshy.jpg?v=1682284148",
    name: "Liza Koshy",
  },
  {
    src: "https://cdn.shopify.com/s/files/1/0492/7201/files/Sherri_Laurence.jpg?v=1682284147",
    name: "Sherri Laurence",
  },
  {
    src: "https://cdn.shopify.com/s/files/1/0492/7201/files/Alexis_Michelle_2.jpg?v=1682284147",
    name: "Alexis Michelle",
  },
  {
    src: "https://cdn.shopify.com/s/files/1/0492/7201/files/Nicky_Doll_6.jpg?v=1682284145",
    name: "Nicky Doll",
  },
  {
    src: "https://cdn.shopify.com/s/files/1/0492/7201/files/Kim_Kardashian_4.jpg?v=1682284145",
    name: "Kim Kardashian",
  },
  {
    src: "https://cdn.shopify.com/s/files/1/0492/7201/files/Drue_de_Milo.jpg?v=1682284145",
    name: "Drue de Milo",
  },
  {
    src: "https://cdn.shopify.com/s/files/1/0492/7201/files/Gelila_Puck.jpg?v=1682284145",
    name: "Gelila Puck",
  },
  {
    src: "https://cdn.shopify.com/s/files/1/0492/7201/files/Nicky_Doll_4.jpg?v=1682284142",
    name: "Nicky Doll",
  },
  {
    src: "https://cdn.shopify.com/s/files/1/0492/7201/files/Jacqueline_Novak.jpg?v=1682284144",
    name: "Jacqueline Novak",
  },
  {
    src: "https://cdn.shopify.com/s/files/1/0492/7201/files/Suki_Waterhouse.jpg?v=1682284141",
    name: "Suki Waterhouse",
  },
  {
    src: "https://cdn.shopify.com/s/files/1/0492/7201/files/Kim_Kardashian_6.jpg?v=1682284139",
    name: "Kim Kardashian",
  },
  {
    src: "https://cdn.shopify.com/s/files/1/0492/7201/files/Christina_Ricci.jpg?v=1682284138",
    name: "Christina Ricci",
  },
  {
    src: "https://cdn.shopify.com/s/files/1/0492/7201/files/Madonna.jpg?v=1682284131",
    name: "Madonna",
  },
  {
    src: "https://cdn.shopify.com/s/files/1/0492/7201/files/Kendall_Jenner_2.jpg?v=1682284138",
    name: "Julia Michaels",
  },
  {
    src: "https://cdn.shopify.com/s/files/1/0492/7201/files/Kim_Kardashian_5.jpg?v=1682284130",
    name: "Kim Kardashian",
  },

  {
    src: "https://cdn.shopify.com/s/files/1/0492/7201/files/Heidi_Klum_6.jpg?v=1682284129",
    name: "Gwyneth Paltrow",
  },
  {
    src: "https://cdn.shopify.com/s/files/1/0492/7201/files/Heidi_Klum_2.jpg?v=1682284133",
    name: "Heidi Klum",
  },
  {
    src: "https://cdn.shopify.com/s/files/1/0492/7201/files/Nick_Jonas.jpg?v=1682284128",
    name: "Nick Jonas",
  },
  {
    src: "https://cdn.shopify.com/s/files/1/0492/7201/files/Heidi_Klum_5.jpg?v=1682284138",
    name: "Heidi Klum",
  },
  {
    src: "https://cdn.shopify.com/s/files/1/0492/7201/files/Selena_Gomez.jpg?v=1682284128",
    name: "Selena Gomez",
  },
  {
    src: "https://cdn.shopify.com/s/files/1/0492/7201/files/Kim_Kardashian.jpg?v=1682284133",
    name: "Kim Kardashian",
  },
  {
    src: "https://cdn.shopify.com/s/files/1/0492/7201/files/Heidi_Klum.jpg?v=1682284134",
    name: "Heidi Klum",
  },
  {
    src: "https://cdn.shopify.com/s/files/1/0492/7201/files/Nicole_Scherzinger.jpg?v=1682284134",
    name: "Nicole Scherzinger",
  },
  {
    src: "https://cdn.shopify.com/s/files/1/0492/7201/files/Florence_Welch_2.jpg?v=1682284127",
    name: "Florence Welch",
  },
];
